import React from 'react';

import { LabelValue, LabelValueTypeConfig, withLabelTokenParsing } from '../common/Content.jsx';
import Token from '../utility/Token.jsx';
import Utilities from '../utility/Utilities.jsx';

// #region PAID

function _Paid(props) {
    const data = props.data || {};
    const blockProps = props.config && props.config.config && props.config.config.Block || {};
    let hasValue;
    if (blockProps.includeNoPayments || (!blockProps.includeNoPayments && data.Payments && data.Payments.length > 0)) {
        hasValue = true;
    }
    return <LabelValue {...props} renderPlaceholder={!hasValue} value={hasValue ? props.content : undefined} />;
}
const Paid = withLabelTokenParsing(_Paid, (props, keyword, options) => {
    const data = props.data || {};
    let replaceString = '';
    switch (keyword) {
        case Token.DisplayCurrency.Paid:
            if (data.ExchangeRate && data.ExchangeRate.Paid != undefined) {
                replaceString = Token.getReplacementString(data.ExchangeRate.Paid, options);
            }
            break;
        case Token.Total.Paid:
            if (data.Paid != undefined) {
                replaceString = Utilities.Format.Currency.getDisplayString(data.Paid, options && options.format, data.Gallery && data.Gallery.Localization);
            }
            break;
        default:
            replaceString = undefined;
            break;
    }
    return replaceString;
});
const Tokens = (data) => {
    const defaultValue = Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization);
    return [
        Token.getCurrencyTokenConfig('Paid', defaultValue, Token.Total.Paid),
        Token.getWrappedTokenConfig('Paid (Display Currency)', Token.DisplayCurrency.Paid)
    ];
};
const TypeConfig = {
    panel: {
        block: () => LabelValueTypeConfig.panel.block(2, [{
            display: 'Display if no payment(s)',
            fullWidth: true,
            group: 'block',
            name: 'includeNoPayments',
            type: 'checkbox',
            value: true
        }]),
        description: LabelValueTypeConfig.panel.description,
        label: () => LabelValueTypeConfig.panel.label(Utilities.wrapTextForEditor({ text: 'Total Paid' })),
        style: LabelValueTypeConfig.panel.style,
        value: (data) => LabelValueTypeConfig.panel.value(Utilities.wrapTextForEditor({ text: `{${Token.Total.Paid}("format":"${Utilities.Format.Currency.getFormatString(data && data.Gallery && data.Gallery.Localization)}")}`, token: Token.Total.Paid }))
    }
};

// #endregion PAID

export {
    Paid as Component,
    Tokens,
    TypeConfig
}